module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social-container hideme"
  }, [_c('div', {
    staticClass: "social"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/theshapeofwater/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icon-fb.png"),
      "alt": "Facebook icon"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "social"
  }, [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/shapeofwatermovie/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icon-ig.png"),
      "alt": "Instagram icon"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "social"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/shapeofwater",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icon-tw.png"),
      "alt": "Twitter icon"
    }
  })])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3dc25707", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dc25707","transformToRequire":{"video":["src","poster"],"source":"src","object":"data","iframe":"src","embed":"src","a":"href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Social.vue
// module id = 399
// module chunks = 0